module.exports = __webpack_public_path__ + "images/green-nature-f1c730664ed8a6137b990b1071416744.jpg";